export default class PronError extends Error{
	constructor(code, msg, details) {
		super(msg);
		this.code = code;
		this.details = details;
	}
}